import { lazy } from 'react';

export const lazyWithRetry = (componentImport: any, path: string) => {
  return lazy(async () => {
    try {
      return await componentImport();
    } catch (error) {
      console.error(`Error tratado - ${path}`, error);
      switch (path) {
        case 'PersonalData':
          return (window.location.href = '/selecao-de-servicos');
        default:
          return window.location.reload();
      }
    }
  });
};
